var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.99991H3.763L7.641 1.76791C8.064 1.41491 8.122 0.783909 7.769 0.359909C7.415 -0.0640909 6.785 -0.122091 6.359 0.231909L0.359 5.23191C0.349 5.24091 0.344 5.25591 0.334 5.26491C0.261 5.33191 0.207 5.41091 0.156 5.49591C0.136 5.52991 0.106 5.55691 0.091 5.59291C0.034 5.71791 0 5.85391 0 5.99991C0 6.14591 0.034 6.28191 0.091 6.40691C0.106 6.44291 0.136 6.46991 0.156 6.50391C0.207 6.58891 0.261 6.66791 0.334 6.73491C0.344 6.74391 0.349 6.75891 0.359 6.76791L6.359 11.7679C6.547 11.9239 6.773 11.9999 6.999 11.9999C7.286 11.9999 7.57 11.8769 7.769 11.6399C8.122 11.2159 8.064 10.5849 7.641 10.2319L3.763 6.99991H17C17.553 6.99991 18 6.55191 18 5.99991C18 5.44791 17.553 4.99991 17 4.99991Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowLeft);
export default __webpack_public_path__ + "static/media/long-arrow-left.40690c5434afe2ba240685ee31adc9c7.svg";
export { ForwardRef as ReactComponent };